/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, inboxId, fetchAll } = {}) {
    const params = {};
    if (searchKey) params.search = searchKey;
    if (inboxId) params.inbox_id = inboxId;
    if (fetchAll) params.fetch_all = fetchAll;

    return axios.get(this.url, { params });
  }
}

export default new CannedResponse();
